import React from "react";
const DivarInternalCarContext = React.createContext({
    isLoading: false,
    process:null,
    postToken:null,
    pid:null,
    components:null,
    token:null,
    handleUpdateStep:()=>{},
    handlePid:()=>{},
    handleInquiryProcess:()=>{},
    handleLoading:()=>{},
    handleProcess:()=>{},
    handleError:()=>{},
    handleComponents:()=>{},
    handleGetProcess:()=>{},
    handleCreateProcess:()=>{},
    handleReset:()=>{},
    handleRedirectToDivar:()=>{}


});
export default DivarInternalCarContext;